export interface IQueryParams {
  [key: string]: string;
}
